module.exports = __webpack_public_path__ + "assets/img/mobile_filter_close.e5cd6804.svg";